import { Link, useLocation } from "react-router-dom";
import breadcrumbNameMap from "./breadcrumbConfig";
import "./Breadcrumbs.css";

export default function Breadcrumbs({ customLabel, extraTrail = [] }) {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <Link className="breadcrumb-item" to="/clm_home">
        Home
      </Link>
      {pathnames.map((value, index) => {
        const to = "/" + pathnames.slice(0, index + 1).join("/");
        const isLastSegment = index === pathnames.length - 1;
        const hasExtras = Array.isArray(extraTrail) && extraTrail.length > 0;
        const isLast = hasExtras ? false : isLastSegment;
        const label = customLabel && isLast ? customLabel : breadcrumbNameMap[to] || decodeURIComponent(value);

        return isLast ? (
          <span key={to}>
            <span className="lpd-breadcrumb-divider">›</span>
            <span className="breadcrumb-current">{label}</span>
          </span>
        ) : (
          <span key={to}>
            <span className="lpd-breadcrumb-divider">›</span>
            <Link className="breadcrumb-item" to={to}>
              {label}
            </Link>
          </span>
        );
      })}
      {Array.isArray(extraTrail) && extraTrail.map((label, idx) => {
        const isLastExtra = idx === extraTrail.length - 1;
        return (
          <span key={`extra-${idx}`}>
            <span className="lpd-breadcrumb-divider">›</span>
            {isLastExtra ? (
              <span className="breadcrumb-current">{label}</span>
            ) : (
              <span className="breadcrumb-item">{label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}